var Eqa = window.Eqa = window.Eqa || {};

window.Eqa.MediaBlock= (function() {
  let lastUniqueId = 0;

  function init() {
    const videoBlocks = document.querySelectorAll('.mediaBlock__wrap--youtube figure');
    
    videoBlocks.forEach(block => {
      const img = block.querySelector('.mediaBlock__imgWrap');
      img.addEventListener('click', play);
    });
  }
  
  function play(e) {
    e.stopPropagation();
    
    const block = e.target.closest('figure');
    const vidHolder = block.querySelector('.ytVideo__holder');
    const videoId = block.dataset.youtubeId;
    
    playYouTube(videoId, vidHolder);
  }
  
  function playYouTube(videoId, holder) {
    if (!window.YT) {
      console.error("YouTube API not loaded.");
      return;
    }
    
    const player = getPlayerEl(holder);
    const targetId = uniqueId();
    player.innerHTML = `<div class='ytVideo__playerTarget' id='${ targetId }'></div>`;
    
    const playerOptions = {
      videoId: videoId,
      hl: window.Eqa.vars.lang,
      events: { 'onReady': e => e.target.playVideo() },
      playerVars: {
        cc_lang_pref: window.Eqa.vars.lang,
        autoplay: 1,
        iv_load_policy: 3,
        enablejsapi: 1,
        rel: 0,
      }        
    };
    
    new YT.Player(targetId, playerOptions);
  }
  
  /**
   * Builds a player element with the specified class (and mediaBlock__player).
   *
   * If such an element already exists, it is returned.
   */
  function getPlayerEl(holder) {
    let player = holder.querySelector('.ytVideo__video');
  
    if (player) { return player; }
    
    player = document.createElement('div');
    player.classList.add('ytVideo__video');
    holder.append(player);
    
    return player;
  }
  
  function uniqueId() {
    return 'mediablock-uniq-' + (lastUniqueId++);
  }

  return { init }
})();
